module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"total":"Total","detailedTrips":"Detailed Trips"},"de":{"total":"Gesamt","detailedTrips":"Detaillierte Fahrten"},"fr":{"total":"Total","detailedTrips":"Trajets détaillés"},"it":{"total":"Totale","detailedTrips":"Viaggi dettagliati"}}')
  delete Component.options._Ctor
}
